<template>
  <b-modal v-model="visible" title="Seleccione los archivos a solicitar">
    <b-row>
      <b-col>
        <b-list-group>
          <b-list-group-item target="_blank" v-for="(file, index) in files" :key="index">
            <b-form-checkbox v-model="file.selected" @input="genMessage">{{ file.name }}</b-form-checkbox>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col>
        <b-form-group label="Mensaje">
          <b-form-textarea rows="10" disabled v-model="message"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>

    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button variant="success" class="float-right" @click="submit">
          <i class="fa fa-send" v-if="!sending"></i>
          <i class="fa fa-spinner fa-spin" v-else></i>

          Enviar
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

export default {
  name: 'ModalCopiaImpresa',
  props: ['tomador', 'nroPoliza', 'nroEndoso'],
  data() {
    return {
      visible: false,
      archivos: [],
      message: '',
      files: [],
      sending: false
    };
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    },
    genMessage() {
      this.message = `Por medio del presente solicito sean enviadas las copias impresas correspondiente a los siguientes archivos del tomador ${this.tomador.nombre}, Póliza ${this.nroPoliza}, Endoso ${this.nroEndoso}:\n\n`;

      for (let file of this.files) {
        if (file.selected) {
          this.message += `- ${file.name}\n`;
        }
      }
    },
    submit: async function() {
      // enviar mensaje
      const selected = this.files.filter(f => f.selected)

      if (!selected.length) {
        this.$toast.error('Seleccione al menos un archivo.')
        return null
      }

      if (!this.message.trim().length) {
        this.$toast.error('Debe ingresar un mensaje.')
        return null
      }

      this.sending = true

      await this.$api.post('endoso/solicitud/copia-impresa', { 
        pas: {
          nombre: (this.$store.state.auth.nombre + ' ' + this.$store.state.auth.apellido).replace('null',''),
          codigo: this.$store.state.auth.cod_agente
        },
        mensaje: this.message,
        cod_tomador: this.tomador.cod_tomador,
        poliza: this.nroPoliza
      }).then(() => {
        this.$toast.success('La solicitud se ha enviado correctamente.')
      }).catch(err => {
        //console.log(err)
        this.$toast.error('Ocurrió un error al enviar la solicitud')
      })

      this.sending = false
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.genMessage();
      } else {
        this.message = '';
      }
    },

    archivos(archivos) {
      const files = [];
      for (let archivo of archivos) {
        const arr = archivo.split('/');

        files.push({
          name: arr[arr.length - 1],
          selected: false
        });
      }

      this.files = files;
    }
  }
};
</script>
